export default __webpack_public_path__ + "static/media/bl_03.d50cb065.jpg";